<template>
  <div class="search-form d-flex pt-2">
    <div class="dropdown search-form-dropdown flex-1">
      <div v-show="searchByOptions?.[search_by]?.text" class="search-input" aria-expanded="false" data-toggle="dropdown">
        <span class="search-type">{{ searchByOptions?.[search_by]?.text }}</span>
        <input type="text" class="form-control flex-1" v-model="search" :placeholder="config.placeholder" @keyup.enter="submit" />
      </div>
      <div tabindex="-1" role="menu" class="dropdown-menu">
        <div class="d-flex flex-column">
          <div v-for="type in searchByOptions" :key="type.id" @click="changeSearchType(type.id)" class="dropdown-item border-0 pl-3 cursor-pointer">
            <span class="search-type">{{ type.text }}</span>
            {{ search }}
          </div>
        </div>
      </div>
    </div>

    <button class="btn btn-light ml-2" @click.stop.prevent="submit">Search</button>
    <div v-if="config.moreFilters" class="btn btn-light mb-0 ml-2" @click.stop.prevent="toggleMoreFilters">
      <i class="ti ti-adjustments"></i>
    </div>
    <div v-if="config.moreActions" class="btn btn-light mb-0 ml-2" @click.stop.prevent="toggleMoreActions">
      <i class="ti ti-grid-dots"></i>
    </div>
  </div>
</template>

<script>
import SearchBox from '@/components/TableList/Plugins/SearchBox.vue'
export default {
  extends: SearchBox,
  computed: {
    extraAttributes() {
      return this.config.extraAttributes || {}
    },
    searchByOptions() {
      return this.extraAttributes?.search_by || []
    }
  },
  methods: {
    changeSearchType(type) {
      this.search_by = type
    }
  }
}
</script>
